<template>
  <div id="app">
    <!-- <div class="d-header">The Construction-integration Model</div>
    <progress class="d-progress" :value="progressCnt" :max="progressMax"></progress> -->
    <div class="d-cont">
        <div class="d-header">The Construction-Integration Model</div>
        <progress class="d-progress" :value="progressCnt" :max="progressMax"></progress>
        <div class="body">
            <div v-if="showDBox" class="d-box">
                <div class="body">
                    <div class="content">
                        <h1 v-if="progressCnt == 0">The Construction-Integration Model</h1>
                        <div v-if="progressCnt == 2" class="dragnDrop row">
                            <div class="col-sm-9">
                                <div class="game-container"> 
                                    <strong style="font-size: 0.92rem;">Drag and drop the terms into their appropriate place on the Construction-Integration Model.</strong>

                                    <img class="left-big-arrow" src="./assets/left-big-arrow.png" alt="no arrow" />
                                    <img class="right-big-arrow" src="./assets/right-big-arrow.png" alt="no arrow" />
                                    <img class="right-small-arrow" src="./assets/right-small-arrow.png" alt="no arrow" />
                                    <div class="cons-sideways">Construction</div>
                                
                                    <draggable
                                        :list="ans1"
                                        class="list-group-ans"
                                        group="choices"
                                        @change="ansChange"
                                    >
                                        <div
                                        :class=" ans1.length > 0 ? 'list-group-ans-item-drag' : 'list-group-ans-drag'" >
                                        {{ ans1[0] }}
                                        </div>
                                    </draggable>

                                    <draggable
                                        :list="ans2"
                                        class="list-group-ans2"
                                        group="choices"
                                        @change="ansChange"
                                    >
                                        <div
                                        :class=" ans2.length > 0 ? 'list-group-ans2-item-drag' : 'list-group-ans2-drag'" >
                                        {{ ans2[0] }}
                                        </div>
                                    </draggable>

                                    <div class="draggable-groups">

                                        <draggable
                                            :list="ans3"
                                            class="list-group-ans3"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans3.length > 0 ? 'list-group-ans3-item-drag' : 'list-group-ans3-drag'" >
                                            {{ ans3[0] }}
                                            </div>
                                        </draggable>

                                        <draggable
                                            :list="ans4"
                                            class="list-group-ans4"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans4.length > 0 ? 'list-group-ans4-item-drag' : 'list-group-ans4-drag'" >
                                            {{ ans4[0] }}
                                            </div>
                                        </draggable>

                                        <draggable
                                            :list="ans5"
                                            class="list-group-ans5"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans5.length > 0 ? 'list-group-ans5-item-drag' : 'list-group-ans5-drag'" >
                                            {{ ans5[0] }}
                                            </div>
                                        </draggable>

                                        <draggable
                                            :list="ans6"
                                            class="list-group-ans6"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans6.length > 0 ? 'list-group-ans6-item-drag' : 'list-group-ans6-drag'" >
                                            {{ ans6[0] }}
                                            </div>
                                        </draggable>

                                        <draggable
                                            :list="ans7"
                                            class="list-group-ans7"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans7.length > 0 ? 'list-group-ans7-item-drag' : 'list-group-ans7-drag'" >
                                            {{ ans7[0] }}
                                            </div>
                                        </draggable>

                                    </div>

                                    <draggable
                                        :list="ans8"
                                        class="list-group-ans8"
                                        group="choices"
                                        @change="ansChange"
                                    >
                                        <div
                                        :class=" ans8.length > 0 ? 'list-group-ans8-item-drag' : 'list-group-ans8-drag'" >
                                        {{ ans8[0] }}
                                        </div>
                                    </draggable>

                                    <draggable
                                        :list="ans9"
                                        class="list-group-ans9"
                                        group="choices"
                                        @change="ansChange"
                                    >
                                        <div
                                        :class=" ans9.length > 0 ? 'list-group-ans9-item-drag' : 'list-group-ans9-drag'" >
                                        {{ ans9[0] }}
                                        </div>
                                    </draggable>

                                    <div class="draggable-groups2">

                                        <draggable
                                            :list="ans10"
                                            class="list-group-ans10"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans10.length > 0 ? 'list-group-ans10-item-drag' : 'list-group-ans10-drag'" >
                                            {{ ans10[0] }}
                                            </div>
                                        </draggable>

                                        <draggable
                                            :list="ans11"
                                            class="list-group-ans11"
                                            group="choices"
                                            @change="ansChange"
                                        >
                                            <div
                                            :class=" ans11.length > 0 ? 'list-group-ans11-item-drag' : 'list-group-ans11-drag'" >
                                            {{ ans11[0] }}
                                            </div>
                                        </draggable>

                                    </div>

                                    <img class="left-solid-arrow" src="./assets/left-solid-arrow.png" alt="no arrow" />
                                    <img class="left-dash-arrow" src="./assets/left-dash-arrow.png" alt="no arrow" />
                                    <img class="center-up-arrow" src="./assets/center-down-arrow.png" alt="no arrow" />
                                    <img class="center-down-arrow" src="./assets/center-down-arrow.png" alt="no arrow" />
                                    <img class="center-one-arrow" src="./assets/center-arrow.png" alt="no arrow" />
                                    <img class="center-two-arrow" src="./assets/center-arrow.png" alt="no arrow" />
                                    <img class="center-three-arrow" src="./assets/center-arrow.png" alt="no arrow" />
                                    <img class="center-four-arrow" src="./assets/center-arrow.png" alt="no arrow" />

                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div> <div :class="correctCnt < 11 ? 'checker-red' : 'checker-green' " v-if="showChecker">You got {{correctCnt}} correct </div> <div class="btn-check" @click="ansCorrectChecker(0)">CHECK <i class="fa fa-check"></i></div> </div>
                                <div class="choices mt-2">
                                    <draggable
                                        :list="choices"
                                        class="list-group"
                                        group="choices"
                                    >
                                        <div
                                        class="list-group-item-drag"
                                        v-for="(choice,index) in choices"
                                        :key="index"
                                        >
                                        {{ choice }}
                                        </div>
                                    </draggable>
                                </div>
                            </div>

                        </div>
                        <div v-if="progressCnt == 3"><h3>You have completed this exercise</h3><br>Thank you for participating</div>
                    </div>
                    <div class="footer">
                        <div v-if="correctCnt == 11" class="successShow text-success"> Well done, you have correctly identified and placed the key terms in the Construction-Integration Model </div>
                        <button class="btn" @click="boxBtn">{{boxBtnText}}</button>
                    </div>
                </div>
            </div>
            <div v-if="showDGame" class="d-game">
                <div class="body">
                    <div class="header">The Construction-Integration Model</div>
                    <div class="target">
                        <p>On the next page is a diagram of the Construction-Integration Model proposed by Kintsch (1992).</p>
                        <p>The key features of the model are shown in boxes.</p>
                        <p>Drag and drop the features into their appropriate boxes.</p>
                        <p>Click NEXT to continue.</p>
                    </div>
                    <div class="footer">
                        <button class="btn btn-target" @click="gameBtn">NEXT</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


  </div>
</template>

<script>

import JQuery from 'jquery';
import draggable from 'vuedraggable';

let $ = JQuery;

export default {
    components: {
        draggable,
    },
  data () {
    return {
        progressCnt: 0,
        progressMax: 3,
        showDBox: false,
        showDGame: false,
        showChecker: false,
        correctCnt: 0,
        correctAns: [],
        boxBtnText: 'START',
        choices: [
            'Words',
            'Perfomance',
            'Long-term memory',
            'Text representation',
            'Learning',
            'Production system',
            'Linguistic representation',
            'Integration',
            'Episodic text memory',
            'Elaborated propositional net',
            'Propositional net'
            ],
        ans1: [],
        ans2: [],
        ans3: [],
        ans4: [],
        ans5: [],
        ans6: [],
        ans7: [],
        ans8: [],
        ans9: [],
        ans10: [],
        ans11: [],
        oldDrag: null,

    }
  },
  created() {
      
  },
  mounted() {
        this.$nextTick(function() {
            window.addEventListener('resize', this._box);
        })

        if(this.progressCnt == 0){
        this.showDBox = true;
        this._box();
        }
  },
  methods: {
    _box() {
        $(document).ready(function(){
            var p = this;
            var main = $(".d-cont");
            main.removeClass("d-scroll");
            var box = $(".d-box");
            
            if (main.outerHeight() <= (box.outerHeight() + 40 + 80) || main.outerWidth() <= (box.outerWidth() + 40 + 80)){
                main.addClass("d-scroll");
                $(".list-group-ans4").css({'margin-top': 16});
                $(".list-group-ans5").css({'margin-top': 16});
                $(".list-group-ans6").css({'margin-top': 16});
                $(".list-group-ans7").css({'margin-top': 16});
                $(".list-group-ans11").css({'margin-top': 16});
                $(".game-container").css({'min-height': 370});
                $(".content > h1").css({'font-size': '1.6rem'});
                $(".cons-sideways").css({'font-size': '0.51rem'});

                if ($(".list-group-ans").is(":visible")){
                    var titleCont = $(".game-container > strong");
                    var ansContainer = $(".list-group-ans");
                    ansContainer.css({'top': titleCont.position().top + titleCont.outerHeight() + 30, 'left': 35});
                }

                if ($(".list-group-ans2").is(":visible")){
                    var ansContainer = $(".list-group-ans");
                    var ans2Container = $(".list-group-ans2");
                    var dragGroups = $(".draggable-groups");
                    var dragGroups2 = $(".draggable-groups2");

                    ans2Container.css({'top': ansContainer.position().top + ansContainer.outerHeight() - 3, 'left': ansContainer.position().left + ansContainer.outerWidth() + 45});

                    var dgroupTop = ans2Container.position().top + ans2Container.outerHeight() + 13;
                    var dgroupLeft = ansContainer.position().left + ansContainer.outerWidth() + 34;
                    dragGroups.css({'top': ans2Container.position().top + ans2Container.outerHeight() + 13, 'left': ansContainer.position().left + ansContainer.outerWidth() + 34});
                    $(".cons-sideways").css({'top': dgroupTop + 30, 'left': dgroupLeft - 40});

                    $(".left-big-arrow").css({'width': 89});
                    $(".left-big-arrow").css({'height': 115});
                    $(".left-big-arrow").css({'top': ansContainer.position().top + ansContainer.outerHeight() + 6});
                    $(".left-big-arrow").css({'left': (ans2Container.position().left / 2) + 12});

                    var dgroup2Top = (ansContainer.position().top + ansContainer.outerHeight() + 6) +  $(".left-big-arrow").outerHeight();
                    var dgroup2Left = ansContainer.position().left - 8;
                    dragGroups2.css({'top': dgroup2Top, 'left': ansContainer.position().left - 8});

                    $(".right-big-arrow").css({'width': 79});
                    $(".right-big-arrow").css({'height': 34});
                    $(".right-big-arrow").css({'top': ansContainer.position().top + ansContainer.outerHeight() + 8});
                    $(".right-big-arrow").css({'left': (ans2Container.position().left) + ans2Container.outerWidth()});

                    $(".right-small-arrow").css({'width': 16});
                    $(".right-small-arrow").css({'height': 10});
                    $(".right-small-arrow").css({'top': dgroupTop + 17});
                    $(".right-small-arrow").css({'left': dgroupLeft + dragGroups.outerWidth() + 1});

                    $(".left-big-arrow").css({'width': 89});
                    $(".left-big-arrow").css({'height': 115});
                    $(".left-big-arrow").css({'top': ansContainer.position().top + ansContainer.outerHeight() + 6});
                    $(".left-big-arrow").css({'left': (ans2Container.position().left / 2) + 12});

                    $(".left-solid-arrow").css({'width': 32});
                    $(".left-solid-arrow").css({'height': 11});
                    $(".left-solid-arrow").css({'top': dgroup2Top + 16});
                    $(".left-solid-arrow").css({'left': dgroup2Left + dragGroups2.outerWidth() - 12});

                    $(".left-dash-arrow").css({'width': 32});
                    $(".left-dash-arrow").css({'height': 11});
                    $(".left-dash-arrow").css({'top': dgroup2Top + 53});
                    $(".left-dash-arrow").css({'left': dgroup2Left + dragGroups2.outerWidth() - 12});

                    $(".center-down-arrow").css({'width': 17});
                    $(".center-down-arrow").css({'height': 26});
                    $(".center-down-arrow").css({'top': dgroupTop + dragGroups.outerHeight() - 12});
                    $(".center-down-arrow").css({'left':dgroupLeft + 50});
                    
                    $(".center-four-arrow").css({'width': 17});
                    $(".center-four-arrow").css({'height': 16});
                    var centerFourTop = (dgroupTop + dragGroups.outerHeight()) - ($('.list-group-ans7').outerHeight() + 12 + $(".center-four-arrow").outerHeight());
                    $(".center-four-arrow").css({'top': centerFourTop});
                    $(".center-four-arrow").css({'left':dgroupLeft + 51});

                    $(".center-three-arrow").css({'width': 17});
                    $(".center-three-arrow").css({'height': 16});
                    var centerThreeTop = centerFourTop - ($('.list-group-ans6').outerHeight() + $(".center-three-arrow").outerHeight());
                    $(".center-three-arrow").css({'top': centerThreeTop});
                    $(".center-three-arrow").css({'left':dgroupLeft + 51});

                    $(".center-two-arrow").css({'width': 17});
                    $(".center-two-arrow").css({'height': 16});
                    var centerTwoTop = centerThreeTop - ($('.list-group-ans5').outerHeight() + $(".center-two-arrow").outerHeight());
                    $(".center-two-arrow").css({'top': centerTwoTop});
                    $(".center-two-arrow").css({'left':dgroupLeft + 51});

                    $(".center-one-arrow").css({'width': 17});
                    $(".center-one-arrow").css({'height': 16});
                    var centerOneTop = centerTwoTop - ($('.list-group-ans4').outerHeight() + $(".center-one-arrow").outerHeight());
                    $(".center-one-arrow").css({'top': centerTwoTop - ($('.list-group-ans4').outerHeight() + $(".center-one-arrow").outerHeight())});
                    $(".center-one-arrow").css({'left':dgroupLeft + 51});

                    $(".center-up-arrow").css({'width': 17});
                    $(".center-up-arrow").css({'height': 26});
                    $(".center-up-arrow").css({'top': centerOneTop - ($('.list-group-ans3').outerHeight() + $(".center-up-arrow").outerHeight())});
                    $(".center-up-arrow").css({'left':dgroupLeft + 51});

                }

                if ($(".list-group-ans8").is(":visible")){
                    var dragGroupContainer = $(".draggable-groups");
                    var ans2Container = $(".list-group-ans2");
                    var top = dragGroupContainer.position().top + dragGroupContainer.outerHeight() + 13;
                    $(".list-group-ans8").css({'top': top, 'left': ans2Container.position().left});
                }

                if ($(".list-group-ans9").is(":visible")){
                    var dragGroupContainer = $(".draggable-groups");
                    var ans9Container = $(".list-group-ans9");
                    var top = dragGroupContainer.position().top + 12;
                    var left = dragGroupContainer.position().left + dragGroupContainer.outerWidth() + 15;
                    $(".list-group-ans9").css({'top': top, 'left': left});
                }
                

            }else{
                main.removeClass("d-scroll");
                var choices = $(".choices");
                $(".choices").css({'min-height': choices.outerHeight()});

                if ($(".list-group-ans2").is(":visible")){
                    var ans2Container = $(".list-group-ans2");
                    $(".left-big-arrow").css({'left': (ans2Container.position().left / 2) - 23});
                    $(".right-big-arrow").css({'left': (ans2Container.position().left) + ans2Container.outerWidth()});
                }

                if ($(".list-group-ans8").is(":visible")){
                    var dragGroupContainer = $(".draggable-groups");
                    var top = dragGroupContainer.position().top + dragGroupContainer.outerHeight() - 5;
                    $(".list-group-ans8").css({'top': top});
                }

            }

            
            

        });
    },
    boxBtn() {
        if(this.progressCnt == 0){
            this.showDBox = false;
            this.showDGame = true;
            this.progressCnt++;
        }else{
            this.ansCorrectChecker(0);
            if(this.correctCnt != 11  && this.progressCnt+1 == 3){
                    $(document).ready(() => {
                        $('.list-group-item-drag').addClass('wrong');
                        setTimeout(function(){
                            $('.list-group-item-drag').removeClass('wrong');
                        },500);
                    });
                    return false;
            }

            this.progressCnt++;
            if(this.progressCnt == 3){
                this.correctCnt = 0;
                this.boxBtnText = 'TRY AGAIN';
            }else if(this.progressCnt == 4){
                this.progressCnt = 0;
                this.boxBtnText = 'START';
                this.showDBox = true;
                this.showDGame = false;
                this.showChecker = false;
                this.correctCnt = 0;
                this.correctAns = [];
                this._box();
                this.choices = [
                    'Words',
                    'Perfomance',
                    'Long-term memory',
                    'Text representation',
                    'Learning',
                    'Production system',
                    'Linguistic representation',
                    'Integration',
                    'Episodic text memory',
                    'Elaborated propositional net',
                    'Propositional net'
                ];
                this.ans1 = [];
                this.ans2 = [];
                this.ans3 = [];
                this.ans4 = [];
                this.ans5 = [];
                this.ans6 = [];
                this.ans7 = [];
                this.ans8 = [];
                this.ans9 = [];
                this.ans10 = [];
                this.ans11 = [];
                this.oldDrag = null;
            }
        }
    },
    gameBtn() {
        this.showDBox = true;
        this.showDGame = false;
        this.progressCnt++;
        this.boxBtnText = 'NEXT';
        this._box();
    },
    ansChange(e) {
        this._box();
        //console.log(e)
        // if(e.added == undefined){
        //     return false;
        // }
        var added = e.added == undefined ? e.removed.element : e.added.element;
    
        if((this.ans1.indexOf(added) > -1 && this.ans1.length > 1)) {
            if(this.ans1.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans1[1]);
                this.ans1.splice(1, 1);
                this.oldDrag = null;
            }else if(this.ans1.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans1[0]);
                this.ans1.splice(0, 1);
                this.oldDrag = null;
            }else if(this.oldDrag != null){
                let ansIndex = this.ans1.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans1[ansIndex])
                this.ans1.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if((this.ans2.indexOf(added) > -1 && this.ans2.length > 1)) {
            if(this.ans2.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans2[1]);
                this.ans2.splice(1, 1);
            }else if(this.ans2.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans2[0]);
                this.ans2.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans2.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans2[ansIndex])
                this.ans2.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans3.indexOf(added) > -1 && this.ans3.length > 1) {
            if(this.ans3.indexOf(added) == 0  && this.oldDrag == null){
                this.choices.push(this.ans3[1]);
                this.ans3.splice(1, 1);
            }else if(this.ans3.indexOf(added) == 1  && this.oldDrag == null){
                this.choices.push(this.ans3[0]);
                this.ans3.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans3.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans3[ansIndex])
                this.ans3.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans4.indexOf(added) > -1 && this.ans4.length > 1) {
            if(this.ans4.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans4[1]);
                this.ans4.splice(1, 1);
            }else if(this.ans4.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans4[0]);
                this.ans4.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans4.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans4[ansIndex])
                this.ans4.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans5.indexOf(added) > -1 && this.ans5.length > 1) {
            if(this.ans5.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans5[1]);
                this.ans5.splice(1, 1);
            }else if(this.ans5.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans5[0]);
                this.ans5.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans5.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans5[ansIndex])
                this.ans5.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans6.indexOf(added) > -1 && this.ans6.length > 1) {
            if(this.ans6.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans6[1]);
                this.ans6.splice(1, 1);
            }else if(this.ans6.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans6[0]);
                this.ans6.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans6.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans6[ansIndex])
                this.ans6.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans7.indexOf(added) > -1 && this.ans7.length > 1) {
            if(this.ans7.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans7[1]);
                this.ans7.splice(1, 1);
            }else if(this.ans7.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans7[0]);
                this.ans7.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans7.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans7[ansIndex])
                this.ans7.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans8.indexOf(added) > -1 && this.ans8.length > 1) {
            if(this.ans8.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans8[1]);
                this.ans8.splice(1, 1);
            }else if(this.ans8.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans8[0]);
                this.ans8.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans8.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans8[ansIndex])
                this.ans8.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans9.indexOf(added) > -1 && this.ans9.length > 1) {
            if(this.ans9.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans9[1]);
                this.ans9.splice(1, 1);
            }else if(this.ans9.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans9[0]);
                this.ans9.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans9.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans9[ansIndex])
                this.ans9.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans10.indexOf(added) > -1 && this.ans10.length > 1) {
            if(this.ans10.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans10[1]);
                this.ans10.splice(1, 1);
            }else if(this.ans10.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans10[0]);
                this.ans10.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans10.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans10[ansIndex])
                this.ans10.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }else if(this.ans11.indexOf(added) > -1 && this.ans11.length > 1) {
            if(this.ans11.indexOf(added) == 0 && this.oldDrag == null){
                this.choices.push(this.ans11[1]);
                this.ans11.splice(1, 1);
            }else if(this.ans11.indexOf(added) == 1 && this.oldDrag == null){
                this.choices.push(this.ans11[0]);
                this.ans11.splice(0, 1);
            }else if(this.oldDrag != null){
                let ansIndex = this.ans11.indexOf(added) == 1 ? 0 : 1;
                this.ansChangeSwitch(this.oldDrag,this.ans11[ansIndex])
                this.ans11.splice(ansIndex, 1);
                this.oldDrag = null;
            }else{
                this.oldDrag = null;
            }
        }
        this.ansCorrectChecker(1);
    },
    ansChangeSwitch(fromDrag,value){
        switch (fromDrag) {
            case 1:
                this.ans1.push(value);
                break;
            case 2:
                this.ans2.push(value);
                break;
            case 3:
                this.ans3.push(value);
                break;
            case 4:
                this.ans4.push(value);
                break;
            case 5:
                this.ans5.push(value);
                break;
            case 6:
                this.ans6.push(value);
                break;
            case 7:
                this.ans7.push(value);
                break;
            case 8:
                this.ans8.push(value);
                break;
            case 9:
                this.ans9.push(value);
                break;
            case 10:
                this.ans10.push(value);
                break;
            case 11:
                this.ans11.push(value);
                break;
        
            
        }
    },
    ansCorrectChecker(auto){
        
        if(this.ans1[0] == 'Learning'){
            this.correctAns[0] = 1;
        }else{
            this.correctAns[0] = 0;
        }

        if(this.ans2[0] == 'Episodic text memory'){
            this.correctAns[1] = 1;
        }else{
            this.correctAns[1] = 0;
        }

        if(this.ans3[0] == 'Text representation'){
            this.correctAns[2] = 1;
        }else{
            this.correctAns[2] = 0;
        }

        if(this.ans4[0] == 'Integration'){
            this.correctAns[3] = 1;
        }else{
            this.correctAns[3] = 0;
        }

        if(this.ans5[0] == 'Elaborated propositional net'){
            this.correctAns[4] = 1;
        }else{
            this.correctAns[4] = 0;
        }

        if(this.ans6[0] == 'Propositional net'){
            this.correctAns[5] = 1;
        }else{
            this.correctAns[5] = 0;
        }

        if(this.ans7[0] == 'Linguistic representation'){
            this.correctAns[6] = 1;
        }else{
            this.correctAns[6] = 0;
        }

        if(this.ans8[0] == 'Words'){
            this.correctAns[7] = 1;
        }else{
            this.correctAns[7] = 0;
        }

        if(this.ans9[0] == 'Perfomance'){
            this.correctAns[8] = 1;
        }else{
            this.correctAns[8] = 0;
        }

        if(this.ans10[0] == 'Long-term memory'){
            this.correctAns[9] = 1;
        }else{
            this.correctAns[9] = 0;
        }

        if(this.ans11[0] == 'Production system'){
            this.correctAns[10] = 1;
        }else{
            this.correctAns[10] = 0;
        }

        if(this.correctAns.length > 0){
            let cnt = 0;
            this.correctAns.forEach(element => {
                if(element == 1){
                    cnt++;
                }
            });

            if(auto == 0 || cnt == 11){
                this.showChecker = true;
                this.correctCnt = cnt;
            }
            
        }else{
            this.correctCnt = 0;
           // this.showChecker = false;
        }

        if(auto == 0 || this.correctCnt == 11){
            this.ansCorrectColors();
        }
    },
    ansCorrectColors(){
        $(document).ready(() => {
            if(this.correctAns[0] != undefined && this.correctAns[0] == 1){
                $('.list-group-ans-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans').removeClass('wrong');
                },500);
            }

            if(this.correctAns[1] != undefined && this.correctAns[1] == 1){
                $('.list-group-ans2-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans2-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans2-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans2-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans2').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans2').removeClass('wrong');
                },500);
            }

            if(this.correctAns[2] != undefined && this.correctAns[2] == 1){
                $('.list-group-ans3-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans3-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans3-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans3-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans3').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans3').removeClass('wrong');
                },500);
            }

            if(this.correctAns[3] != undefined && this.correctAns[3] == 1){
                $('.list-group-ans4-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans4-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans4-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans4-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans4').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans4').removeClass('wrong');
                },500);
            }

            if(this.correctAns[4] != undefined && this.correctAns[4] == 1){
                $('.list-group-ans5-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans5-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans5-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans5-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans5').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans5').removeClass('wrong');
                },500);
            }

            if(this.correctAns[5] != undefined && this.correctAns[5] == 1){
                $('.list-group-ans6-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans6-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans6-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans6-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans6').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans6').removeClass('wrong');
                },500);
            }

            if(this.correctAns[6] != undefined && this.correctAns[6] == 1){
                $('.list-group-ans7-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans7-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans7-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans7-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans7').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans7').removeClass('wrong');
                },500);
            }

            if(this.correctAns[7] != undefined && this.correctAns[7] == 1){
                $('.list-group-ans8-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans8-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans8-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans8-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans8').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans8').removeClass('wrong');
                },500);
            }

            if(this.correctAns[8] != undefined && this.correctAns[8] == 1){
                $('.list-group-ans9-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans9-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans9-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans9-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans9').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans9').removeClass('wrong');
                },500);
            }

            if(this.correctAns[9] != undefined && this.correctAns[9] == 1){
                $('.list-group-ans10-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans10-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans10-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans10-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans10').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans10').removeClass('wrong');
                },500);
            }

            if(this.correctAns[10] != undefined && this.correctAns[10] == 1){
                $('.list-group-ans11-item-drag').addClass('correct');
                setTimeout(function(){
                    $('.list-group-ans11-item-drag').removeClass('correct');
                },500);
            }else{
                $('.list-group-ans11-item-drag').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans11-item-drag').removeClass('wrong');
                },500);

                $('.list-group-ans11').addClass('wrong');
                setTimeout(function(){
                    $('.list-group-ans11').removeClass('wrong');
                },500);
            }
        });
    }

  },
  watch: {
      ans1(newVal,old){
          if(newVal.length == 0)this.oldDrag = 1;
      },
      ans2(newVal,old){
          if(newVal.length == 0)this.oldDrag = 2;
      },
      ans3(newVal,old){
          if(newVal.length == 0)this.oldDrag = 3;
      },
      ans4(newVal,old){
          if(newVal.length == 0)this.oldDrag = 4;
      },
      ans5(newVal,old){
          if(newVal.length == 0)this.oldDrag = 5;
      },
      ans6(newVal,old){
          if(newVal.length == 0)this.oldDrag = 6;
      },
      ans7(newVal,old){
          if(newVal.length == 0)this.oldDrag = 7;
      },
      ans8(newVal,old){
          if(newVal.length == 0)this.oldDrag = 8;
      },
      ans9(newVal,old){
          if(newVal.length == 0)this.oldDrag = 9;
      },
      ans10(newVal,old){
          if(newVal.length == 0)this.oldDrag = 10;
      },
      ans11(newVal,old){
          if(newVal.length == 0)this.oldDrag = 11;
      },
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this._box);
  },
}
</script>

<style>
html,body{
    padding:0px;
    margin:0px;
    height:100%;
    width:100%;
    overflow:hidden;
    font-size:20px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
}
body{
    color:black;
}

.d-cont {
    width: 100%;
    height: 100%;
    /* max-width: 1200px;
    max-height: 800px; */
    position: absolute;
    transform: translate(-50%,-50%);
    left: 50%;
    top: 50%;
}

.d-cont > .body{
    position:relative;
    width:100%;
    height:100%;
}

.d-box{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-box > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-box > .body > .content{
    position: relative;
    padding: 20px;
    border: 5px solid #000000;
    margin-bottom: 20px;
    color: #000000;
    border-radius: 10px;
}

.d-box > .body > .footer{
    text-align:right;
}

.d-game{
    position:fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    max-width:900px;
    width:98%;
    text-align:center;
}
.d-game > .body{
    position:relative;
    width:100%;
    height:100%;
}
.d-game > .body > .header{
    position: relative;
    padding: 20px;
    border: 5px solid #000000;
    margin-bottom: 20px;
    border-radius: 10px;
    font-size: 35px;
    font-weight: 700;
}
.d-game > .body > .target{
    position:relative;
    padding:20px;
    border:5px solid #000000;
    margin-bottom:20px;
    border-radius: 10px;
    height:auto;
    max-height: 500px;
    text-align: left;
}
.d-game > .body > .target > .content{
    position:relative;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    height:100%;
    width:100%;
    padding:10px;
    max-width:500px;
    max-height:200px;
}

.d-game > .body > .footer{ 
    text-align:right; 
}

.btn{
    background-color: #dddddd !important;
}


.d-cont.d-scroll{
    max-height: unset;
    position: absolute;
    transform: translate(-50%,0%);
    top: 0px;
    overflow:auto;
    width: 100%;
    max-width: unset;
}
.d-cont.d-scroll > .body{
    padding:10px;
}

.d-cont.d-scroll .d-box{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}

.d-cont.d-scroll .d-game{
    position:relative;
    top:70px;
    transform: translate(-50%,0%);  
    margin:0px 0px;
}


.d-progress{
    border: none;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 5px;
    z-index:9999;
    background: #86888b;
}

.d-progress::-webkit-progress-value {
  background: #86888b;
}

.d-progress::-moz-progress-bar {
  background: #86888b;
}
.d-progress::-webkit-progress-value {
  background: #86888b;
}
.d-progress::-webkit-progress-bar {
  background: #dddddd;
}

.d-header {
    position: fixed;
    top: 0px;
    font-size: 30px;
    font-weight: 700;
    background: black;
    width: 100%;
    color: white;
    padding: 10px;
    text-align: center;
    z-index: 9998;
}

.checker-red {
    color: red;
    font-size: 0.68rem;
    display: inline;
}

.checker-green {
    color: #28a745;
    font-size: 0.68rem;
    display: inline;
}

.btn-check {
    font-size: 0.68rem;
    top: 5px;
    font-weight: 600;
    text-align: right;
    display: inline;
}

.choices {
    border: 1px dashed #989898;
    min-height: 250px;
    padding: 10px;
}

.list-group-item-drag{
    position: relative;
    display: block;
    padding: 5px 2px;
    margin-bottom: -1px;
    background-color: #959698;
    border: 1px solid rgba(0,0,0,.125);
    font-size: 0.73rem;
    margin-top: 3px;
    margin-bottom: 3px;
}

.list-group-ans {
    position: absolute;
    min-width: 180px;
    min-height: 33px;
    border: 1px dashed #c5c5c5;
    top: 60px;
}

.list-group-ans-drag {
    position: relative;
}

.list-group-ans-item-drag {
    position: relative;
    border: 1px dashed #f9f9f9;
    background-color: #959698;
    font-size: 0.68rem;
    padding: 5px 2px;
}

.list-group-ans2 {
    position: absolute;
    min-width: 180px;
    min-height: 33px;
    border: 1px dashed #c5c5c5;
    top: 50px;
    transform: translate(240px, 30px);
}

.list-group-ans2-drag, .list-group-ans3-drag, .list-group-ans4-drag, .list-group-ans5-drag, .list-group-ans6-drag, .list-group-ans7-drag, .list-group-ans8-drag, .list-group-ans9-drag, .list-group-ans10-drag, .list-group-ans11-drag {
    position: relative;
}


.list-group-ans2-item-drag, .list-group-ans3-item-drag, .list-group-ans4-item-drag, .list-group-ans5-item-drag, .list-group-ans6-item-drag, .list-group-ans7-item-drag, .list-group-ans8-item-drag, .list-group-ans9-item-drag, .list-group-ans10-item-drag, .list-group-ans11-item-drag  {
    position: relative;
    background-color: #959698;
    font-size: 0.68rem;
    padding: 5px 2px;
}

.left-big-arrow {
    position: absolute;
    top: 90px;
    width: 152px;
    height: 195px;
}

.right-big-arrow {
    position: absolute;
    top: 95px;
    width: 135px;
    height: 55px;
}

.right-small-arrow {
    position: absolute;
    top: 161px;
    width: 24px;
    height: 13px;
    left: 447px;
}

.left-solid-arrow {
    position: absolute;
    top: 308px;
    width: 42px;
    height: 17px;
    left: 204px;
}

.left-dash-arrow {
    position: absolute;
    top: 367px;
    width: 42px;
    height: 17px;
    left: 204px;
}

.center-one-arrow {
    position: absolute;
    top: 185px;
    width: 19px;
    height: 26px;
    left: 334px; 
}

.center-two-arrow {
    position: absolute;
    top: 245px;
    width: 19px;
    height: 26px;
    left: 334px; 
}

.center-three-arrow {
    position: absolute;
    top: 305px;
    width: 19px;
    height: 26px;
    left: 334px; 
}

.center-four-arrow {
    position: absolute;
    top: 365px;
    width: 19px;
    height: 26px;
    left: 334px; 
}

.center-up-arrow {
    position: absolute;
    top: 114px;
    width: 23px;
    height: 37px;
    left: 332px;
}

.center-down-arrow {
    position: absolute;
    top: 425px;
    width: 23px;
    height: 35px;
    left: 330px;
}

.draggable-groups {
    position: absolute;
    min-width: 190px;
    min-height: 224px;
    border: 1px dashed #848484;
    background-color: #ececec;
    top: 110px;
    -webkit-transform: translate(230px, 30px);
    transform: translate(230px, 30px);
    padding: 10px;
}

.draggable-groups2 {
    position: absolute;
    min-width: 190px;
    min-height: 100px;
    border: 1px dashed #848484;
    background-color: #ececec;
    top: 254px;
    -webkit-transform: translate(0px, 30px);
    transform: translate(0px, 30px);
    padding: 10px;
}

.list-group-ans3, .list-group-ans4, .list-group-ans5, .list-group-ans6, .list-group-ans7, .list-group-ans10, .list-group-ans11 {
    position: relative;
    min-width: 180px;
    min-height: 33px;
    border: 1px dashed #c5c5c5;
    background-color: #ffffff;
    max-width: 180px;
}

.list-group-ans4, .list-group-ans5, .list-group-ans6, .list-group-ans7, .list-group-ans11 {
    margin-top: 27px;
    max-width: 180px;
}

.list-group-ans8 {
    position: absolute;
    min-width: 180px;
    min-height: 33px;
    transform: translate(240px, 30px);
    border: 1px dashed #c5c5c5;
}

.list-group-ans9 {
    position: absolute;
    min-width: 180px;
    min-height: 33px;
    top: 121px;
    -webkit-transform: translate(452px, 30px);
    transform: translate(452px, 30px);
    border: 1px dashed #c5c5c5;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > strong {
    font-size: 0.7rem;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans > .list-group-ans-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans2, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans2 > .list-group-ans2-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
    transform: unset;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans3, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans3 > .list-group-ans3-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans4, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans4 > .list-group-ans4-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans5, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans5 > .list-group-ans5-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans6, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans6 > .list-group-ans6-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans7, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans7 > .list-group-ans7-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans8, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans8 > .list-group-ans8-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
    transform: unset;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans9, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div.list-group-ans9 > .list-group-ans9-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
    transform: unset;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans10, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans10 > .list-group-ans10-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans11, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > div > div.list-group-ans11 > .list-group-ans11-item-drag {
    min-width: 95px;
    min-height: 20px;
    font-size: 0.52rem;
    padding: 0px 0px;
    max-width: 95px;
}

.d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > .draggable-groups, .d-cont.d-scroll > div.body > div > div > div.content > div > div.col-sm-9 > div > .draggable-groups2 {
    min-width: 116px;
    min-height: 50px;
    transform: unset;
}

.correct{
    background: #70ce86;
}

.wrong{
    background: #c36e76;
}

.cons-sideways{
    position: absolute;
    transform: rotate(-90deg);
    font-size: 0.7rem;
    font-weight: 700;
    top: 185px;
    left: 185px;
}

.successShow {
    position: absolute;
    left: 50%;
    transform: translate(-61%, 0px);
    width: 67%;
    font-weight: 700;
    font-size: 0.9rem;
    text-align: center;
}


@media only screen and (max-width: 1000px) {
    .d-ins .ins-img{
        width:auto;
        height:80px;
        margin:0px 5px;
    }  
    
    .d-game > .body > .header{
        padding: 10px;
        border: 5px solid #000000;
        margin-bottom: 10px;
        border-radius: 10px;
        font-size: 20px;
    }   

    .list-group-item-drag{
        font-size: 0.55rem;
    }

    .col-sm-9 > strong{
        font-size: 0.69rem;
    }
    
    .checker {
        font-size: 0.55rem;
        margin-bottom: 5px;
        margin-top: 10px;
    }
     

    
}

@media only screen and (max-width: 700px) { 

    .list-group-item-drag{
        font-size: 0.55rem;
    }

    .col-sm-9 > strong{
        font-size: 0.69rem;
    }
    
    .checker {
        font-size: 0.55rem;
        margin-bottom: 5px;
        margin-top: 10px;
    }

    .d-header {
        font-size: 17px;
    }
     
    .btn-check {
        font-size: 0.58rem;
    }

    .body > .target {
        margin-bottom: 0.6rem;
        font-size: 0.9rem;
    }

    .body > .content > h1 {
        font-size: 1.6rem;
    }

    .body > .content > h4 {
        font-size: 1.3rem;
    }

    
}


</style>
